import { useMemo } from "react";

export default useQueryParams;

function useQueryParams() {
  const { search } = window.location;

  return useMemo(() => new URLSearchParams(search), [search]);
}
